import React, { useEffect } from "react";
import Settings from "./Settings";
// import {useNavigate} from 'react-router-dom';
// import { Redirect } from '@shopify/app-bridge/actions';
// import { useAppBridge } from '@shopify/app-bridge-react';

const Home = () => {
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  const shop = urlParams.get("shop");
  console.log("ShopURL", shop);
  return (
    <>
      <Settings shopUrl={shop} />
    </>
  );
};

export default Home;
